import type { FaireProductEntity } from "../../entity_types/product";

export const p_rjar8wcagd: FaireProductEntity = {
  token: "p_rjar8wcagd",
  type: "product",
  name: "EMF 5G Pet Protection Orgone Crystal Dog Charm over 30 lbs",
  brandToken: "b_qpub74vn67",
  brandName: "Secret Synergy Stones",
  imageUrl:
    "https://cdn.faire.com/fastly/f5fc8dd6b259eb238d260a5550810565a863e6066c4f5ef7ff862ec0ccee06d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e89dadbdf8a17d454b3ffd3bbf69f791ae04ceb72079aa558a0c47b5452b7c60.jpeg",
    "https://cdn.faire.com/fastly/c75a62f6171117312dc4fe3ccf338ca769b3fe82a29955193b68839ad10e2e38.jpeg",
    "https://cdn.faire.com/fastly/2d6d90ce8ae6000297b3c2843f30490d7bdeec658141002d60cfa3e0b9f3ef38.jpeg",
    "https://cdn.faire.com/fastly/5bf3d5f10bc5524badd791a0e5fc44890aa81eca94679cc728a927015fe35ca3.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "EMF 5G Pet Protection Orgonite Crystal Paw Print Dog Charm with Orgone, Shungite, Black Tourmaline & Rose Quartz ~ plus Secret Synergy Proprietary Blend of Healing Crystals for Stunning Holistic Harmony.\n\n5G, EMF & Harmful Radiation: In today's society it's impossible to avoid potentially harmful Electromagnetic Fields. Shungite may be used to block or diminish EMFs. \n\nOur combining of these Synergy Stones provides the strongest protection available.  24/7 Protection from possible Wi-Fi exposures.\n\nMay relieve Anxiety & Stress plus Reduce Pain & Inflammation while Boosting the Immune System.\n\nEver Lasting Positive Energy. Extremely Durable/Strong construction. \n\nAll items are handmade using real stones. Weight,  size, shape & color may vary. Your selected choice is one-of-a-kind piece created lovingly with positive energy\n\nHand Made in the U.S.A. \n",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:19.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
